var Backbone, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportServiceActionsBaseView = (function(superClass) {
  extend(SupportServiceActionsBaseView, superClass);

  function SupportServiceActionsBaseView() {
    return SupportServiceActionsBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportServiceActionsBaseView.prototype.linkIdentifier = function() {
    return 'LINK';
  };

  SupportServiceActionsBaseView.prototype.defaultButtonIdentifier = function() {
    return "DEFAULT_BUTTON";
  };

  SupportServiceActionsBaseView.prototype.secondaryButtonIdentifier = function() {
    return 'SECONDARY_BUTTON';
  };

  SupportServiceActionsBaseView.prototype.setButtonType = function(button_type) {
    return this.button_type = button_type;
  };

  SupportServiceActionsBaseView.prototype.buttonHash = function() {
    switch (this.button_type) {
      case this.linkIdentifier():
        return {
          showLinkCTA: true
        };
      case this.secondaryButtonIdentifier():
        return {
          showSecondaryCTA: true
        };
      default:
        return {
          showDefaultCTA: true
        };
    }
  };

  SupportServiceActionsBaseView.prototype.isSingleGroupon = function() {
    return this.order.groupons.length === 1;
  };

  SupportServiceActionsBaseView.prototype.extendSingleGrouponParams = function(hash) {
    hash.showHyperlink = true;
    return _.extend(hash, {
      grouponId: this.order.groupons[0].id
    });
  };

  SupportServiceActionsBaseView.prototype.extendHash = function(hash) {
    return _.extend(hash, this.buttonHash(), window.getOrderInfoForBH(this.order));
  };

  return SupportServiceActionsBaseView;

})(Backbone.View);

module.exports = SupportServiceActionsBaseView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvc2VydmljZV9hY3Rpb25fYmFzZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3NlcnZpY2VfYWN0aW9ucy9zZXJ2aWNlX2FjdGlvbl9iYXNlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHVDQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7OzBDQUNKLGNBQUEsR0FBZ0IsU0FBQTtXQUNkO0VBRGM7OzBDQUdoQix1QkFBQSxHQUF5QixTQUFBO1dBQ3ZCO0VBRHVCOzswQ0FHekIseUJBQUEsR0FBMkIsU0FBQTtXQUN6QjtFQUR5Qjs7MENBRzNCLGFBQUEsR0FBZSxTQUFDLFdBQUQ7V0FDYixJQUFDLENBQUEsV0FBRCxHQUFlO0VBREY7OzBDQUdmLFVBQUEsR0FBYSxTQUFBO0FBQ1gsWUFBTyxJQUFDLENBQUEsV0FBUjtBQUFBLFdBQ08sSUFBQyxDQUFBLGNBQUQsQ0FBQSxDQURQO2VBRUk7VUFDRSxXQUFBLEVBQWEsSUFEZjs7QUFGSixXQUtPLElBQUMsQ0FBQSx5QkFBRCxDQUFBLENBTFA7ZUFNSTtVQUNFLGdCQUFBLEVBQWtCLElBRHBCOztBQU5KO2VBVUk7VUFDRSxjQUFBLEVBQWdCLElBRGxCOztBQVZKO0VBRFc7OzBDQWViLGVBQUEsR0FBaUIsU0FBQTtXQUNkLElBQUMsQ0FBQSxLQUFLLENBQUMsUUFBUSxDQUFDLE1BQWhCLEtBQTBCO0VBRFo7OzBDQUdqQix5QkFBQSxHQUEyQixTQUFDLElBQUQ7SUFDekIsSUFBSSxDQUFDLGFBQUwsR0FBcUI7V0FDckIsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxJQUFULEVBQWU7TUFBQyxTQUFBLEVBQVcsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFTLENBQUEsQ0FBQSxDQUFFLENBQUMsRUFBL0I7S0FBZjtFQUZ5Qjs7MENBSTNCLFVBQUEsR0FBWSxTQUFDLElBQUQ7V0FDVixDQUFDLENBQUMsTUFBRixDQUFTLElBQVQsRUFBZSxJQUFDLENBQUEsVUFBRCxDQUFBLENBQWYsRUFBK0IsTUFBTSxDQUFDLGlCQUFQLENBQXlCLElBQUMsQ0FBQSxLQUExQixDQUEvQjtFQURVOzs7O0dBbkM4QixRQUFRLENBQUM7O0FBc0NyRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
